<template>
  <v-dialog v-model="dialog" persistent max-width="850px">
    <v-card>
      <ModelTitle title="Edit Price Tier" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              autofocus
              :hide-details="nameErrors.length === 0"
              dense
              :error-messages="nameErrors"
              v-model="PriceTier.name"
              label="Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="PriceTier.discountType"
              :items="[
                { text: 'Percentage', value: 'percentage' },
                { text: 'Fixed', value: 'fixed' },
              ]"
              item-text="text"
              item-value="value"
              label="Discount Type"
              hide-details
              outlined
              dense
            ></v-select>
          </v-col>

          <v-col cols="6" v-if="PriceTier.discountType === 'percentage'">
            <v-text-field
              v-model="PriceTier.rate"
              label="Percentage Value"
              type="number"
              :min="0"
              :max="100"
              outlined
              dense
              hide-details="auto"
              :error-messages="percentageErrors"
            />
          </v-col>
        </v-row>
        <div v-if="PriceTier.discountType === 'fixed'">
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="search"
                outlined
                prepend-inner-icon="search"
                autofocus
                dense
                label="Search"
                single-line
                style="min-width: 250px"
                hide-details
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="7">
              <AutoComplete
                @submit="productSubmitted"
                ref="selectedProductChild"
                @emptyEntryBar="emptyEntryBar()"
              />
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field
                outlined
                dense
                :hide-details="priceErrors.length === 0"
                :error-messages="priceErrors"
                @focus="$event.target.select()"
                class="right-input"
                v-model="selectedValue.price"
                label="Price"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                color="primary"
                :loading="loading"
                dark
                @click="addProduct()"
                >Add</v-btn
              >
            </v-col>
          </v-row>

          <div
            style="max-height: 500px; overflow-y: auto"
            class="mt-4"
            v-if="Products.length > 0"
          >
            <v-data-table
              :mobile-breakpoint="0"
              :headers="headers"
              :items="Products"
              :search="search"
              :items-per-page="Products.length"
              hide-default-footer
            >
              <template v-slot:item="{ item, index }">
                <tr class="pointer">
                  <td class="text-left">{{ item.Category.name }}</td>
                  <td class="text-left">
                    {{ item.name }}
                    <v-avatar v-if="item.priceFound" size="10" color="red">
                    </v-avatar>
                  </td>
                  <td class="text-left">{{ item.price | currency }}</td>
                  <td class="text-left">
                    <v-text-field
                      v-model="item.priceTier"
                      outlined
                      :min="0"
                      prepend-inner-icon="mdi-clipboard-check-outline"
                      class="al-r"
                      type="number"
                      @click:prepend-inner="copyPrice(item, index)"
                      hide-details
                      @focus="$event.target.select()"
                      dense
                    ></v-text-field>
                  </td>
                  <td class="justify-end align-center text-right">
                    <v-btn @click="deletePrice(item)" icon>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div v-else class="text-center grey--text mt-10">
            <div class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <div class="text-center">Please wait... Loading products</div>
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PriceTierService from "../service.js";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
import productService from "@/modules/Product/service";
import AutoComplete from "@/modules/Product/components/AutoComplete.vue";

export default {
  name: "edit-PriceTier",
  props: {
    editDialog: Boolean,
    editPriceTier: Object,
  },
  data() {
    return {
      Products: [],
      phoneSearch: null,
      selectedProduct: null,
      search: null,
      headers: [
        {
          text: "Category",
          align: "left",
          value: "Category.name",
          sortable: true,
        },
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Price",
          align: "left",
          value: "price",
          sortable: true,
        },
        {
          text: "Price Tier",
          align: "left",
          width: "150px",
          value: "priceTier",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      loading: false,
      showCustomerPriceDialog: false,
      dialog: false,
      PriceTier: {
        name: null,
        discountType: "percentage",
        rate: null,
      },
      selectedValue: {
        price: 0,
        name: null,
        ProductId: null,
      },
      customPrices: [],
      products: [],
    };
  },
  mixins: [validationMixin],
  validations: {
    PriceTier: {
      name: { required },
    },
    selectedValue: {
      price: {
        required,
      },
    },
  },
  components: {
    AutoComplete,
  },
  computed: {
    priceErrors() {
      const errors = [];
      if (!this.$v.selectedValue.price.$dirty) return errors;
      if (!this.$v.selectedValue.price.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.PriceTier.name.$dirty) return errors;
      if (!this.$v.PriceTier.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    percentageErrors() {
      const value = this.PriceTier.rate;
      const errors = [];
      if (value === null || value === "") return errors;
      if (isNaN(value)) errors.push("Must be a number");
      else if (value < 0) errors.push("Cannot be less than 0%");
      else if (value > 100) errors.push("Cannot be more than 100%");
      return errors;
    },
  },
  watch: {
    async editDialog(val) {
      this.dialog = val;
      if (val && this.editPriceTier) {
        await this.loadPriceTier(this.editPriceTier);
        await this.getProductList();
      }
    },
    // phoneSearch(val) {
    //   if (val && val.length === 1) {
    //     this.getProduct();
    //   }
    // },
    selectedProduct(val) {
      if (val) {
        this.selectedValue.ProductId = val.id;
        this.selectedValue.price = val.price;
        this.selectedValue.name = val.name;
      }
    },
  },
  methods: {
    copyPrice(item, index) {
      this.$swal({
        title: "Change Price To All",
        text: `You want to change all ${
          item.Category.name
        } price to ${this.$options.filters.currency(item.priceTier)}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.Products = this.Products.map((product) => {
            if (product.CategoryId === item.CategoryId) {
              return {
                ...product,
                priceTier: item.priceTier,
              };
            }
            return product;
          });

          this.$swal({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            icon: "success",
            title: `Price updated for all ${item.Category.name} products`,
          });
        }
      });
    },
    getProductList() {
      console.log("i got call");
      return productService.getAll().then((response) => {
        console.log("getProductList", response);

        this.Products = response.data;
        // response.data = response.data.map((p) => {
        //   p.priceTier = p.price;
        //   this.Products.push(p);
        // });

        this.Products.forEach((product) => {
          // check if this product exists in customPrices
          // const hasCustomPrice = this.customPrices.some(
          //   (cp) => cp.ProductId === product.id
          // );

          const customPrice = this.customPrices.find(
            (cp) => cp.ProductId === product.id
          );

          if (customPrice) {
            // found custom price object
            product.priceFound = true;
            product.priceTier = customPrice.price;
          } else {
            // no custom price, use default
            product.priceFound = false;
            product.priceTier = product.price || 0; // default to product price if not found
          }

          // only add default price to priceTier if not found in customPrices
          // if (!hasCustomPrice) {
          //   product.priceTier = product.price;
          //   product.priceFound = false;
          // } else {
          //   console.log(
          //     "Custom Price Found for Product:",
          //     product.name,
          //     hasCustomPrice
          //   );
          //   product.priceTier = hasCustomPrice.price;
          //   product.priceFound = true;
          // }
        });
      });
    },
    productSubmitted(val) {
      this.selectedProduct = val;
    },
    emptyEntryBar() {
      this.weight = null;
      this.weightQty = null;
      this.weightboxPrice = 0;
      this.name = null;
      this.qty = 1;
      this.boxQty = 1;
      this.total = 0;
      this.price = 0;
      this.phoneSearch = null;
      this.selectedProduct = null;
      this.dialog = false;
      this.imeiNumber = false;
      this.Products = [];
      this.selected = [];
      setTimeout(() => {
        // this.$refs.productSearch.focus();
        // console.log('selectedProductChild', this.$refs)
        this.$refs.selectedProductChild.$refs.productSearchInput.focus();
      }, 300);
      this.error = [];
      if (this.$refs?.selectedProductChild) {
        this.$refs.selectedProductChild.emptyAutoComplete();
      }
    },
    // getProduct() {
    //   this.loading = true;
    //   return productService.getAll().then((result) => {
    //     this.Products = result.data;
    //     this.loading = false;
    //   });
    // },
    addProduct() {
      if (this.selectedValue) {
        const alreadyExists = this.customPrices.some(
          (p) => p.ProductId === this.selectedValue.ProductId
        );
        if (alreadyExists) {
          const productName =
            this.products.find((p) => p.id === this.selectedValue.ProductId)
              ?.name || "This product";
          this.$swal.fire({
            icon: "warning",
            title: `${productName} is already in the list`,
            toast: true,
            position: "top-end",
            timer: 3000,
            showConfirmButton: false,
          });
          return;
        }
        this.customPrices.push(this.selectedValue);
        this.emptyEntryBar();
        // this.$nextTick(() => {
        //   this.$refs.productSearch?.focus(); // focus on autocomplete
        // });
        setTimeout(() => {
          this.$refs.productSearch?.focus(); // blur the autocomplete
        }, 100);
      }
    },
    getProductPrice() {
      return PriceTierService.getById(this.editPriceTier.id).then(
        (response) => {
          console.log("Product Price Response:", response);

          this.PriceTiers = response.data;
          if (response.data.ProductPrices.length > 0) {
            this.customPrices = response.data.ProductPrices.filter(
              (p) => p.Product
            ) // ✅ only keep items that have a Product
              .map((p) => {
                return {
                  ProductId: p.ProductId,
                  name: p.Product.name,
                  price: p.price,
                };
              });
            // this.customPrices = response.data.ProductPrices;
          }
          // console.log("this.customPrices", this.customPrices);
          return response;
        }
      );
    },
    async loadPriceTier(data) {
      this.PriceTier = {
        id: data.id,
        name: data.name || "",
        discountType: data.discountType || "percentage",
        rate: data.rate || null,
      };

      if (data.discountType === "fixed") {
        console.log("i m in fix price");
        await this.getProductPrice();
      } else {
        this.customPrices = [];
      }
      // this.customPrices = data.customPrices || [];
      return this.customPrices;
    },
    init() {
      this.PriceTier = { ...this.value };
      this.customPrices = this.value.customPrices || [];
      this.$v.$reset();
    },
    deletePrice(item) {
      this.customPrices = this.customPrices.filter((p) => p !== item);
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    emptyEntryBar() {
      this.selectedValue = {
        price: 0,
        name: null,
        ProductId: null,
      };
      this.selectedProduct = null;
      this.phoneSearch = null;
      this.$v.selectedValue.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal.fire({ icon: "error", title: "Invalid fields" });
        return;
      }

      if (
        this.PriceTier.discountType === "percentage" &&
        (this.PriceTier.rate === null || this.PriceTier.rate === "")
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Percentage Value is required.",
        });
        return;
      }

      if (
        this.PriceTier.discountType === "fixed" &&
        (!this.customPrices || this.customPrices.length === 0)
      ) {
        this.$swal.fire({
          icon: "error",
          title: "At least one product is required for fixed pricing.",
        });
        return;
      }

      this.loading = true;
      let newCustomPrice = [];
      this.Products.forEach((product) => {
        const originalPrice = product.price ?? 0;
        if (originalPrice != product.priceTier) {
          const customPrice = {
            ProductId: product.id,
            name: product.name,
            price: product.priceTier,
          };

          newCustomPrice.push(customPrice);
        }
      });

      const payload = {
        ...this.PriceTier,
        customPrices:
          this.PriceTier.discountType === "fixed" ? newCustomPrice : [],
      };

      console.log("Submitting Price Tier:", payload);

      PriceTierService.update(payload.id, payload)
        .then(() => {
          this.loading = false;
          this.$emit("submit");
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.$swal.fire({ icon: "error", title: err.data.message });
        });
    },
  },
};
</script>

<style scoped>
</style>